import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { EntityType } from '../../entity.types';
import { EntityInfos } from '../infos/EntityInfos';
import { getEntityIdUrlSearch } from '../../charts/chartsUtils';
import { Hyperlink } from '../../../components/Hyperlink';
import { buildUrlWithParameters } from '../../../utils/url-utils/urlUtils';
import { getPageName } from '../../../utils/pageName';
import styles from './entity_keywords.module.scss';
import {
  EntityBlock,
  EntityBlockTitle,
} from '../../components/EntityBlockComponents';

type Props = {
  keywords: Array<string>;
  decisionCount: number;
  entityId: string;
  entityName: string;
  entityType: EntityType;
  dontShowHref?: boolean;
};

export const EntityKeywords: FC<Props> = ({
  keywords,
  decisionCount,
  entityName,
  entityId,
  entityType,
  dontShowHref,
}) => {
  const buildUrl = (keyword: string) => {
    return buildUrlWithParameters('/search', {
      q: encodeURIComponent(`${entityName} ${keyword.toLowerCase()}`),
      [getEntityIdUrlSearch(entityType)]: entityId,
      chrono: true,
      sourcePage: getPageName(),
    });
  };

  return (
    <EntityBlock>
      <EntityBlockTitle>
        <FormattedMessage id="entity/expertises/keywords/EntityKeywords.tsx/1" />
      </EntityBlockTitle>
      <EntityInfos
        decisionCount={decisionCount}
        entityType={entityType}
        lawyerId={entityId}
        entityName={entityName}
      />
      <div className="entity__block__value-line entity__block__head-label">
        <span>
          <FormattedMessage id="entity/expertises/keywords/EntityKeywords.tsx/2" />
        </span>
      </div>
      <div>
        {keywords.map(keyword => (
          <Hyperlink
            key={keyword}
            className={`${styles.container} entity__block__label`}
            href={dontShowHref ? undefined : buildUrl(keyword)}
            source="expertise_keyword"
          >
            {keyword}
          </Hyperlink>
        ))}
      </div>
    </EntityBlock>
  );
};
